import Icon from 'veui/components/Icon'

Icon.register({
  medal: {
    paths: [
      {
        d: 'M702.07 627.54L606 363.55a240 240 0 10-444 0l-96.08 264a32 32 0 0043.59 39.94l94.05-43.85 43.85 94a32 32 0 0029 18.48h1.41a32 32 0 0028.67-21L380.43 512h7.14l73.94 203.13a32 32 0 0028.67 21h1.41a32 32 0 0029-18.48l43.85-94 94.05 43.85a32 32 0 0043.59-39.94zM384 96c97.05 0 176 79 176 176s-78.95 176-176 176-176-78.95-176-176S287 96 384 96zM272.77 620.61l-24.72-53a32 32 0 00-42.53-15.48l-53 24.73 52.69-144.76q4.41 4.92 9.11 9.64a238.91 238.91 0 00101.57 60.52zm289.71-68.51A32 32 0 00520 567.58l-24.72 53-43.14-118.35a238.91 238.91 0 00101.57-60.52q4.71-4.71 9.11-9.64l52.69 144.76zM480 288a32 32 0 01-32-32 64.07 64.07 0 00-64-64 32 32 0 010-64 128.14 128.14 0 01128 128 32 32 0 01-32 32z'
      }
    ],
    width: '768',
    height: '768'
  }
})
